module.exports = __webpack_public_path__ + "img/pay_notice.53bd2282.png";